import { lazy } from 'react';

const MerchantResubmit = lazy(() => import('./MerchantResubmit'));

const MerchantResubmitConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: '/merchant/resubmit',
      element: <MerchantResubmit />,
    },
  ],
};

export default MerchantResubmitConfig;
